<template>
  <label>{{ translate(`${LOCALE_PREFIX}.form.tenders.taxExempt`) }}</label>
  <SelectButtonField
    :id="`touchnet-tax-exempt`"
    :name="`${formNamespace}tax_exempt`"
    :options="taxExemptOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { useMealPlan } from '../../composables';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set meal plan composable
const { taxExemptOptions } = useMealPlan();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
const formNamespace = inject('formNamespace', '');
</script>
